import ActualBoatToolbar from "./ActualBoatToolbar";
import Card from "@mui/material/Card";
import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";

import { useLayoutContext } from "@ntg/component-library/contexts";
import { CSGrid } from "@ntg/components/grids";

const title = ("Actual Boat Search").toUpperCase();

export default function ActualBoatSearch() {
    const { SetSecondaryHeader, SetPrimaryTitle } = useLayoutContext();
    const [test, setTest] = React.useState<string>("");
    const [searchTerm, setSearchTerm] = React.useState<string>("");

    useEffect(() => {
        // SetPrimaryHeader(<Typography key="ActualBoatSearch" variant="h6">{title}</Typography>);
        SetPrimaryTitle(title);
        SetSecondaryHeader(
            <ActualBoatToolbar
                SearchTerm={searchTerm}
                key="ActualBoatToolbar"
                onValueChange={(value: string): void => {
                    setSearchTerm(value);
                    setTest("Searching for " + value);
                }}
            />
        );

        return () => {
            SetPrimaryTitle("");
            SetSecondaryHeader(null);
        };
    }, [SetPrimaryTitle, SetSecondaryHeader, searchTerm]);

    return (
        <>
            <CSGrid
                gap={1}
                minColumnWidth={190}
                variant="outlined"
            >
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
            </CSGrid>
            <CSGrid
                gap={1}
                minColumnWidth={190}
                variant="outlined"
            >
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
            </CSGrid>
            <CSGrid
                gap={1}
                minColumnWidth={190}
                variant="outlined"
            >
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
            </CSGrid>        <CSGrid
                gap={1}
                minColumnWidth={190}
                variant="outlined"
            >
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
            </CSGrid>
            <CSGrid
                gap={1}
                minColumnWidth={190}
                variant="outlined"
            >
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
                <Card style={{ padding: "16px" }} variant="outlined">
                    <Typography variant="body1">
                        Actual Boat Search Component
                    </Typography>
                    <Typography variant="body2">{test}</Typography>
                </Card>
            </CSGrid>
        </>
    );
}